import React from "react";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import { Select } from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import { properCase } from "LIB/formatters/text";
import { RECEIVED } from "APP_ROOT/constants";
import ActionFormSection from "./ActionFormSection";
import {
  ACTION_REQUESTED,
  APPROVAL_STATUS,
  EXPECTED_COMPONENT,
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_REJECTED,
  TEARDOWN
} from "../../../../../constants";

const getFieldName = index => {
  if (index !== undefined) {
    return `line_items[${index}].action_requested`;
  }
  return "action_requested";
};

export default function ActionRequestedSection({
  actions,
  change,
  exchange,
  setField,
  getField,
  getInitialFieldValue,
  shopAssistRepairOrder,
  repairOrder,
  index = undefined,
  editing = false,
  nested = false,
  originalEvalGreaterThanOutrightVal,
  outrightValue,
  tierType,
  disabled = false,
  showEvaluationFields = true,
  onActionChange = () => {}
}) {
  const name = getFieldName(index);
  const action = getField(name);
  const isDisabledTeardown =
    !getField(RECEIVED) &&
    getField(ACTION_REQUESTED) === TEARDOWN &&
    [REPAIR_EVALUATION_REJECTED, REPAIR_EVALUATION_APPROVED].includes(
      getField(APPROVAL_STATUS)
    );
  return [
    <div
      className="row row-col-gutters-half"
      style={{ marginTop: 10 }}
      key="repairs_0"
    >
      <Col md={6}>
        <Field
          name={name}
          component={Select}
          options={toOptions(actions)}
          label={properCase(ACTION_REQUESTED)}
          required
          disabled={
            disabled ||
            (editing &&
              (getInitialFieldValue(ACTION_REQUESTED) === EXPECTED_COMPONENT ||
                isDisabledTeardown))
          }
          onChange={onActionChange}
        />
      </Col>
    </div>,
    <div key="repairs_1">
      {action && (
        <ActionFormSection
          action={action}
          change={change}
          exchange={exchange}
          repairOrder={repairOrder}
          setField={setField}
          getField={getField}
          getInitialFieldValue={getInitialFieldValue}
          editing={editing}
          index={index}
          shopAssistRepairOrder={shopAssistRepairOrder}
          nested={nested}
          originalEvalGreaterThanOutrightVal={
            originalEvalGreaterThanOutrightVal
          }
          outrightValue={outrightValue}
          showEvaluationFields={showEvaluationFields}
          tierType={tierType}
          disabled={disabled}
        />
      )}
    </div>
  ];
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/ActionRequested/ActionRequestedSection.jsx